<template>
	<div class="cart">
		<!-- precart -->
		<div v-if="eventGaStepOneData.bool" class="precart">
			<div class="precart__top">
				<p class="precart__p precart__p--bold precart__p--1">
					Have you already your purchased General Admission Tickets?
				</p>
				<p class="precart__p precart__p--2">
					Continue to checkout with just your event selection
				</p>
				<p class="precart__p precart__p--bold precart__p--3">
					{{ eventGaStepOneData.month }} {{ eventGaStepOneData.day }},
					{{ eventGaStepOneData.time }}
				</p>
				<p class="precart__p precart__p--4">{{ eventGaStepOneData.title }}</p>
				<ul class="precart__ul">
					<li
						class="precart__li"
						v-for="(tick, index) in eventGaStepOneData.tickets"
						v-bind:key="index"
						v-if="eventGaStepOneData.tickets[index].count > 0"
					>
						<p class="precart__p">{{ tick.type }}</p>
						<p class="precart__p precart__p--bold">x{{ tick.count }}</p>
					</li>
				</ul>
			</div>
			<button @click="addPrecartToCartWarning()" class="precart__btn">
				<p class="precart__p precart__p--bold precart__p--5">
					Add to cart without General Admission
					<span><PrecartArrow></PrecartArrow></span>
				</p>
			</button>
		</div>
		<!-- cart -->
		<div class="cart__cart" v-if="cartData && cartData.Products">
			<!-- CountDown Warning -->
			<div v-if="timeWarning === true" class="timeWarning">
				<div class="timeWarning__window">
					<p class="timeWarning__prompt">
						Your cart is expiring soon. Click below to reserve your ticket(s) or
						they will be removed from your cart.
					</p>
					<div class="timeWarning__extendBtn" @click="extendTimer">
						<p>Extend timer</p>
					</div>
				</div>
			</div>
			<!-- session expired warning -->
			<div v-if="timeTerminated === true" class="timeWarning">
				<div class="timeWarning__window">
					<p class="timeWarning__prompt">
						We’re sorry, but your session has expired. Please click below to
						start again.
					</p>
					<div class="timeWarning__extendBtn" @click="signOut">
						<p>New session</p>
					</div>
				</div>
			</div>
			<!-- CountDown Clock -->
			<div class="cart__typeTime">
				<h2 class="cart__h2">Cart</h2>
				<div class="cart__timebox">
					<CartClock></CartClock>
					<p v-if="timer" class="cart__timer">{{ timer }}</p>
				</div>
			</div>
			<p class="cart__p">Please review before continuing</p>

			<!-- Packages and Performances Container -->
			<div
				v-if="cartPackages || cartPerformances"
				class="cart__perfAndPackagesWrapper"
			>
				<div
					class="cart__packagesContainer"
					v-if="cartPackages !== null || cartPerformances !== null"
				>
					<!-- Performances -->
					<div
						v-if="cartPerformances"
						class="cart__packageItem"
						v-for="(item, index) in cartPerformances"
						v-bind:key="item.id"
					>
						<!-- Performances Edit Button -->
						<div
							@click="openEditMenu(true, index, 'cartPerformances')"
							v-if="item.editMenu === false"
							class="cart__actions cart__actions--btn"
						>
							<p>Edit</p>
							<EditCarrot></EditCarrot>
						</div>

						<!-- Performances Edit Button Open -->
						<div v-if="item.editMenu === true" class="cart__actions">
							<div
								@click="openEditMenu(false, index, 'cartPerformances')"
								class="cart__actionsTop"
							>
								<p>Edit</p>
								<EditCarrot class="cart__carrot--open"></EditCarrot>
							</div>

							<ul>
								<li
									class="cart__actionsLi"
									@click="editPrompt(index, 'cartPerformances')"
								>
									Change Selection
								</li>
								<li
									class="cart__actionsLi"
									@click="removePrompt(index, 'cartPerformances')"
								>
									Delete Selection
								</li>
							</ul>
						</div>

						<!-- Performances Remove Confirmation -->
						<div
							v-if="item.removeConfirmation === true"
							class="timeWarning timeWarning__window"
						>
							<p class="timeWarning__prompt">
								Are you sure you would like to remove this item?
							</p>
							<div
								v-if="item.performanceTitle !== 'Ropes Mansion'"
								@click="
									removePerformanceId(
										item.performanceId,
										item.lineItemId,
										false
									)
								"
								class="timeWarning__extendBtn"
							>
								Yes
							</div>
							<div
								v-if="item.performanceTitle === 'Ropes Mansion'"
								@click="
									removeRopesTicket(item.performanceId, item.lineItemId, false)
								"
								class="timeWarning__extendBtn"
							>
								Yes
							</div>
							<div
								@click="item.removeConfirmation = false"
								class="timeWarning__extendBtn"
							>
								No
							</div>
						</div>

						<!-- Performances Edit Confirmation -->
						<div
							v-if="item.editConfirmation === true"
							class="timeWarning timeWarning__window"
						>
							<p class="timeWarning__prompt">
								Are you sure you would like to edit this item?
							</p>
							<div
								v-if="item.performanceTitle !== 'Ropes Mansion'"
								@click="
									removePerformanceId(item.performanceId, item.lineItemId, true)
								"
								class="timeWarning__extendBtn"
							>
								Yes
							</div>
							<div
								v-if="item.performanceTitle === 'Ropes Mansion'"
								@click="
									removeRopesTicket(item.performanceId, item.lineItemId, true)
								"
								class="timeWarning__extendBtn"
							>
								Yes
							</div>
							<div
								@click="item.editConfirmation = false"
								class="timeWarning__extendBtn"
							>
								No
							</div>
						</div>

						<!-- Performances Info -->
						<p class="cart__date">
							{{ months[item.date.getMonth()] }} {{ item.date.getDate() }},
							{{ item.date.getFullYear() }} {{ item.formattedTime }}
						</p>

						<div class="cart__group">
							<div v-if="item.performanceTitle" class="cart__groupTopLine">
								<p class="cart__ticketEventTitle">
									{{ item.performanceTitle }}
								</p>
							</div>
						</div>
						<div
							class="cart__ticketInfo"
							v-for="(display, index) in item.displayLines"
							v-bind:key="index"
						>
							<div class="cart__titleAmount">
								<p class="cart__gaTicketType cart__gaTicketType--title">
									{{ display.title }}
								</p>

								<p class="cart__gaTicketCount">
									<span>x </span>{{ display.count }}
								</p>
							</div>
							<p class="cart__gaTicketType cart__gaTicketType--price">
								${{ display.price }}
							</p>
						</div>
						<div class="cart__gaSubtotal">
							<p class="cart__gaTicketType">Subtotal</p>
							<p class="cart__gaTicketType">${{ item.performanceTotal }}</p>
						</div>
					</div>

					<!-- Packages -->
					<div
						v-if="cartPackages"
						class="cart__packageItem"
						v-for="(item, index) in cartPackages"
						v-bind:key="item.lineItemId"
					>
						<!-- Packages Edit Button -->
						<div
							@click="openEditMenu(true, index, 'cartPackages')"
							v-if="item.editMenu === false"
							class="cart__actions cart__actions--btn"
						>
							<p>Edit</p>
							<EditCarrot></EditCarrot>
						</div>

						<!-- Packages Edit Menu Open -->
						<div v-if="item.editMenu === true" class="cart__actions">
							<div
								@click="openEditMenu(false, index, 'cartPackages')"
								class="cart__actionsTop"
							>
								<p>Edit</p>
								<EditCarrot class="cart__carrot--open"></EditCarrot>
							</div>

							<ul>
								<li
									class="cart__actionsLi"
									@click="editPrompt(index, 'cartPackages')"
								>
									Change Selection
								</li>
								<li
									class="cart__actionsLi"
									@click="removePrompt(index, 'cartPackages')"
								>
									Delete Selection
								</li>
							</ul>
						</div>

						<!-- Packages Edit Confirmation -->
						<div
							v-if="item.editConfirmation === true"
							class="timeWarning timeWarning__window"
						>
							<p class="timeWarning__prompt">
								Are you sure you would like to edit this item?
							</p>
							<div
								@click="removePackageId(item.lineItemId, true)"
								class="timeWarning__extendBtn"
							>
								Yes
							</div>
							<div
								@click="item.editConfirmation = false"
								class="timeWarning__extendBtn"
							>
								No
							</div>
						</div>

						<!-- Packages Remove Confirmation -->
						<div
							v-if="item.removeConfirmation === true"
							class="timeWarning timeWarning__window"
						>
							<p class="timeWarning__prompt">
								Are you sure you would like to remove this item?
							</p>
							<div
								@click="removePackageId(item.lineItemId, false)"
								class="timeWarning__extendBtn"
							>
								Yes
							</div>
							<div
								@click="item.removeConfirmation = false"
								class="timeWarning__extendBtn"
							>
								No
							</div>
						</div>

						<!-- Package Info -->
						<p class="cart__date">
							{{ item.month }} {{ item.dayOfMonth }}, {{ item.year }}
							{{ item.formattedTime }}
						</p>

						<div
							class="cart__group"
							v-for="(perf, index) in item.performances"
							v-bind:key="index"
						>
							<div
								v-if="
									perf.performanceTitle === 'General Admission' ||
									perf.performanceTitle === 'Lunar New Year Afternoon'
								"
								class="cart__groupTopLine"
							>
								<p class="cart__ticketReason">
									{{ perf.performanceTitle }}
								</p>
							</div>
							<div
								v-if="
									perf.performanceTitle === 'General Admission' ||
									perf.performanceTitle === 'Lunar New Year Afternoon'
								"
							>
								<div
									class="cart__ticketInfo"
									v-for="(display, index) in perf.displayLines"
									v-bind:key="index"
								>
									<div class="cart__titleAmount">
										<p class="cart__gaTicketType cart__gaTicketType--title">
											{{ display.title }}
										</p>

										<p class="cart__gaTicketCount">
											<span>x </span>{{ display.count }}
										</p>
									</div>
									<p class="cart__gaTicketType cart__gaTicketType--price">
										${{ display.price }}
									</p>
								</div>
							</div>
							<div
								v-if="
									perf.performanceTitle !== 'General Admission' &&
									perf.performanceTitle !== 'Lunar New Year Afternoon'
								"
								class="cart__ticketInfo"
							>
								<div class="cart__titleAmount">
									<p
										v-if="
											perf.performanceTitle === 'Yin Yu Tang: A Chinese Home' ||
											perf.performanceTitle === 'Yin Yu Tang: A Chinese House'
										"
										class="cart__gaTicketType cart__gaTicketType--title"
									>
										Yin Yu Tang
									</p>
									<p
										v-if="perf.performanceTitle === 'Ropes Mansion'"
										class="cart__gaTicketType cart__gaTicketType--title"
									>
										{{ perf.performanceTitle }}
									</p>
									<p class="cart__gaTicketCount">
										<span>{{ perf.displayLines[0].yytTime }}</span>
									</p>
								</div>
								<p class="cart__gaTicketType cart__gaTicketType--price">
									${{ perf.displayLines[0].total }}
								</p>
							</div>
						</div>
						<div class="cart__gaSubtotal">
							<p class="cart__gaTicketType">Subtotal</p>
							<p class="cart__gaTicketType">${{ item.packTotal }}</p>
						</div>
					</div>
				</div>
			</div>
			<!-- Total -->
			<div v-if="cartData && !eventGaStepOneData.bool" class="cart__totalLine">
				<p class="cart__gaTicketType">Total</p>
				<p class="cart__gaTicketType" v-if="this.cartData.CartAmount !== 0">
					${{ this.cartData.CartAmount }}
				</p>
				<p
					class="cart__gaTicketType cart__totalBuffer"
					v-if="this.cartData.CartAmount === 0"
				>
					$0
				</p>
			</div>

			<!-- Checkout -->
			<!-- <div
				v-if="eventGaStepOneData.bool === true"
				class="cart__checkoutBtnContainer b"
				@click="setPrecartWarningTrue()"
			>
				<div class="cart__checkoutA">
					<div class="cart__checkoutBtn">Checkout</div>
				</div>
			</div> -->
			<div class="cart__checkoutBtnContainer a">
				<a class="cart__checkoutA" :href="checkoutUrl">
					<div class="cart__checkoutBtn">Checkout</div>
				</a>
			</div>

			<!-- Mobile - back to adding tickets -->
			<div v-if="mobile && ticketAdded" class="cart__backToTickets">
				<div @click="ticketAddedFalse" class="cart__backButton">
					<p>Add another selection</p>
					<AnotherSelectionArrow></AnotherSelectionArrow>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import CartClock from './svg/CartClock';
import EditCarrot from './svg/EditCarrot';
import AnotherSelectionArrow from './svg/AnotherSelectionArrow';
import PrecartArrow from './svg/PrecartArrow';
import { set } from 'vue';
var Vue = require('vue');
export default {
	name: 'Cart',
	props: {
		cartData: Object,
		eventGaStepOneData: Object,
		sessionKey: String,
		cart: Array,
		mobile: Boolean,
		ticketAdded: Boolean,
		checkoutUrl: String,
		redirectUrl: String,
	},
	components: {
		CartClock,
		PrecartArrow,
		EditCarrot,
		AnotherSelectionArrow,
	},
	data() {
		return {
			timeWarning: false,
			timeTerminated: false,
			timeAlreadyExtended: false,
			timer: null,
			timerInterval: null,
			newKey: null,
			countdownExpiration: null,
			triggerRedirect: false,
			months: [
				'January',
				'February',
				'March',
				'April',
				'May',
				'June',
				'July',
				'August',
				'September',
				'October',
				'November',
				'December',
			],
		};
	},
	watch: {
		triggerRedirect() {
			if (this.triggerRedirect === false) {
				return;
			}
			this.redirect();
		},
	},
	methods: {
		addPrecartToCartWarning() {
			this.$emit('precartWarningToggle', true);
		},
		addPrecartToCart() {
			this.$emit('precartAdded');
		},
		setPrecartWarningTrue() {
			$('html,body').scrollTop(0);
			this.$emit('precartWarningToggle', true);
		},
		signOut() {
			let that = this;
			$.get('/actions/my-module/default/sign-out', {
				sessionKey: that.sessionKey,
			}).done(function () {
				that.triggerRedirect = true;
			});
		},
		redirect() {
			window.location.replace('' + this.redirectUrl + '');
		},
		extendTimer() {
			let that = this;
			$.get(
				'/actions/my-module/default/extend-cart-expiration',
				{
					session: that.sessionKey,
					extendTime: that.expirationExtendFormatted,
				},
				function (res) {
					that.timeAlreadyExtended = true;
					that.timeWarning = false;
				}
			).done(function () {
				that.getExpiration();
			});
		},
		timeExtensionCookieUpdate() {
			let cookieCart = this.$cookies.get(this.sessionKey);
			cookieCart[0].timeAlreadyExtended = 'true';
			this.$cookies.set(this.sessionKey, JSON.stringify(cookieCart));
		},
		openEditMenu(bool, index, string) {
			switch (string) {
				case 'cartPerformances':
					if (bool === true) {
						this.cartPerformances[index].editMenu = true;
					} else {
						this.cartPerformances[index].editMenu = false;
					}
					break;
				case 'cartPackages':
					if (bool === true) {
						this.cartPackages[index].editMenu = true;
					} else {
						this.cartPackages[index].editMenu = false;
					}
					break;
			}
		},

		removePrompt(index, string) {
			switch (string) {
				case 'cartPerformances':
					this.cartPerformances[index].editMenu = false;
					this.cartPerformances[index].removeConfirmation = true;
					break;
				case 'cartPackages':
					this.cartPackages[index].editMenu = false;
					this.cartPackages[index].removeConfirmation = true;
					break;
			}
		},
		editPrompt(index, string) {
			switch (string) {
				case 'cartPerformances':
					this.cartPerformances[index].editMenu = false;
					this.cartPerformances[index].editConfirmation = true;
					break;
				case 'cartPackages':
					this.cartPackages[index].editMenu = false;
					this.cartPackages[index].editConfirmation = true;
					break;
			}
		},
		editPackageId(lineItemId) {
			let sessionCookie = this.$cookies.get(this.sessionKey);
			let packageToEdit = sessionCookie.filter((obj) => {
				if (obj.event === undefined) {
					return obj.nfsPackageLineItemId === lineItemId;
				}
			});
			this.$emit('updatePackage', packageToEdit);
			this.removePackageId(lineItemId);
		},
		removePackageId(lineItemId, bool) {
			this.$emit('cartEditSetLoading', true);
			let that = this;
			$.get(
				'/actions/my-module/default/remove-package',
				{ session: that.sessionKey, removeId: lineItemId },
				function (res) {}
			).done(function () {
				$.get(
					'/actions/my-module/default/get-cart-details',
					{ session: that.sessionKey },
					function (res) {
						let jsonData = JSON.parse(res);
						that.$emit('updateCart', jsonData);
					}
				).done(function () {
					if (bool === true) {
						let sessionCookie = that.$cookies.get(that.sessionKey);
						let packageToEdit = sessionCookie.filter((obj) => {
							if (obj.event === undefined) {
								return obj.nfsPackageLineItemId === lineItemId;
							}
						});
						that.$emit('updatePackage', packageToEdit);
					}
					that.$emit('cookieCartUpdate', lineItemId);
					if (that.cartPerformances === false && that.cartPackages === false) {
						that.ticketAddedFalse();
					}
				});
				that.$emit('cartEditSetLoading', false);
			});
		},
		removeRopesTicket(performanceId, lineItemId, bool) {
			this.$emit('cartEditSetLoading', true);
			let that = this;
			$.get('/actions/my-module/default/remove-event', {
				session: that.sessionKey,
				lineItemId: lineItemId,
				performanceId: performanceId,
			}).done(function () {
				$.get(
					'/actions/my-module/default/get-cart-details',
					{ session: that.sessionKey },
					function (res) {
						let jsonData = JSON.parse(res);
						that.$emit('updateCart', jsonData);
						that.$emit('cartEditSetLoading', false);
						if (bool === true) {
							that.$emit('openRopes');
						}
					}
				);
			});
		},
		removePerformanceId(performanceId, lineItemId, bool) {
			this.$emit('cartEditSetLoading', true);
			let that = this;
			$.get('/actions/my-module/default/remove-event', {
				session: that.sessionKey,
				lineItemId: lineItemId,
				performanceId: performanceId,
			}).done(function () {
				$.get(
					'/actions/my-module/default/get-cart-details',
					{ session: that.sessionKey },
					function (res) {
						let jsonData = JSON.parse(res);
						that.$emit('updateCart', jsonData);
					}
				).done(function () {
					if (bool === false) {
						if (
							that.cartPerformances === false &&
							that.cartPackages === false
						) {
							that.ticketAddedFalse();
						}
						that.$emit('cookieCartEventUpdate', lineItemId);
						that.$emit('cartEditSetLoading', false);
					} else {
						let sessionCookie = that.$cookies.get(that.sessionKey);
						let performanceToEdit = sessionCookie.filter((obj) => {
							if (obj.event) {
								return obj.event.lineItemId === lineItemId;
							}
						});
						that.$emit('cookieCartEventUpdate', lineItemId);
						that.$emit('renderModal', performanceToEdit[0].event);
						that.ticketAddedFalse();
						that.$emit('cartEditSetLoading', false);
					}
				});
			});
		},
		getExpiration() {
			let that = this;
			$.get(
				'/actions/my-module/default/get-expiration',
				{ session: that.sessionKey },
				function (res) {
					let resParsed = JSON.parse(res);
					clearInterval(that.timerInterval);
					that.countdownExpiration = resParsed.Expiration;
					let countDownDate = null;
					countDownDate = new Date(resParsed.Expiration).getTime();

					that.timerInterval = setInterval(function () {
						// Get today's date and time
						let now = new Date().getTime();

						// Find the distance between now and the count down date
						let distance = countDownDate - now;

						// Time calculations for days, hours, minutes and seconds
						let minutes = Math.floor(
							(distance % (1000 * 60 * 60)) / (1000 * 60)
						);
						let seconds = Math.floor((distance % (1000 * 60)) / 1000);
						if (seconds < 10) {
							seconds = '0' + seconds;
						}

						that.timer = minutes + ':' + seconds;

						// If the countdown is finished, do something
						if (distance < 120000) {
							that.timeWarning = true;
						}
						if (distance < 0) {
							that.timeWarning = false;
							that.timeTerminated = true;
						}
						if (distance < -5000) {
							that.signOut();
						}
					}, 1000);
				}
			);
		},
		ticketAddedFalse() {
			$(window).scrollTop(0);
			this.$emit('falseTicketAdded');
		},
	},

	computed: {
		cartPackages() {
			if (
				this.cartData === null ||
				this.cartData.Products === null ||
				this.cartData.Products === undefined
			) {
				return null;
			}

			// if this is a package
			let packageArray = this.cartData.Products.filter(
				(pack) => pack.ProductClass.Id === 2
			);
			if (packageArray.length) {
				return packageArray.map((item, index) => {
					// Find the performance with "General Admission"
					const generalAdmissionPerf = item.Package.Performances.find(
						(perf) =>
							perf.PerformanceDescription === 'General Admission' ||
							perf.PerformanceDescription === 'Lunar New Year Afternoon'
					);

					let date = null;
					let formattedTime = null;
					let month = null;
					let dayOfMonth = null;
					let year = null;
					if (generalAdmissionPerf) {
						const dateTime = new Date(generalAdmissionPerf.PerformanceDateTime);

						// Format the date
						date = new Date(dateTime);
						// Get the month
						month = this.months[date.getMonth()];
						// Get day of month
						dayOfMonth = date.getDate();
						// Get year
						year = date.getFullYear();
						// Extract and format the time
						let hours = dateTime.getHours();
						let minutes = dateTime.getMinutes();
						const ampm = hours >= 12 ? 'pm' : 'am';

						// Convert 24-hour time to 12-hour time
						hours = hours % 12 || 12; // Converts 0 to 12 for midnight
						minutes = minutes < 10 ? `0${minutes}` : minutes; // Add leading zero if necessary

						// Format the time
						formattedTime = `${hours}:${minutes} ${ampm}`;

						// Remove leading zero if present in the formatted time
						if (formattedTime.startsWith('0')) {
							formattedTime = formattedTime.slice(1);
						}

						// Replace specific time
						if (formattedTime === '5:00 pm') {
							formattedTime = '10:00 am';
						}
					}

					return {
						lineItemId: item.Package.LineItemId,
						packTotal: item.Package.TotalAmount,
						editMenu: false,
						editConfirmation: false,
						removeConfirmation: false,
						date: date, // Add the date as its own line item
						formattedTime: formattedTime, // Add the formatted time as its own line item
						month: month,
						dayOfMonth: dayOfMonth,
						year: year,
						performances: item.Package.Performances.map((perf, index) => ({
							performanceTitle: perf.PerformanceDescription,
							displayLines: perf.DisplayLines.map((dis, index) => ({
								title: dis.PriceTypeDescription,
								count: dis.Count,
								price: dis.Price,
								total: dis.Total,
								yytTime: dis.ZoneShortDescription,
							})).sort((a, b) =>
								a.title > b.title ? 1 : b.title > a.title ? -1 : 0
							),
						})),
					};
				});
			} else {
				return false;
			}
		},

		cartPerformances() {
			if (
				this.cartData === null ||
				this.cartData.Products === null ||
				this.cartData.Products === undefined
			) {
				return null;
			}
			let performanceArray = this.cartData.Products.filter(
				(pack) => pack.ProductClass.Id === 1
			);
			if (performanceArray.length) {
				return performanceArray.map((item) => {
					const dateTime = new Date(item.Performance.PerformanceDateTime);

					// Extract and format the time
					let hours = dateTime.getHours();
					let minutes = dateTime.getMinutes();
					const ampm = hours >= 12 ? 'pm' : 'am';

					// Convert 24-hour time to 12-hour time
					hours = hours % 12 || 12; // Converts 0 to 12 for midnight
					minutes = minutes < 10 ? `0${minutes}` : minutes; // Add leading zero if necessary

					// Format the time
					let formattedTime = `${hours}:${minutes} ${ampm}`;

					// Remove leading zero if present in the formatted time
					if (formattedTime.startsWith('0')) {
						formattedTime = formattedTime.slice(1);
					}
					if (item.Performance.PerformanceDescription === 'Ropes Mansion') {
						formattedTime =
							item.Performance.DisplayLines[0].ZoneShortDescription.toLowerCase();
					}

					return {
						date: dateTime,
						formattedTime: formattedTime, // Add formatted time
						performanceId: item.Performance.PerformanceId,
						lineItemId: item.Performance.LineItemId,
						performanceTotal: item.Performance.TotalAmount,
						editMenu: false,
						editConfirmation: false,
						removeConfirmation: false,
						performanceTitle: item.Performance.PerformanceDescription,
						displayLines: item.Performance.DisplayLines.map((dis, index) => ({
							title: dis.PriceTypeDescription,
							count: dis.Count,
							price: dis.Price,
							total: dis.Total,
						})).sort((a, b) =>
							a.title > b.title ? 1 : b.title > a.title ? -1 : 0
						),
					};
				});
			} else {
				return false;
			}
		},

		expirationExtendFormatted() {
			if (this.timeAlreadyExtended === true) {
				return;
			}
			let extendedDateTime = new Date(this.countdownExpiration.toString());
			extendedDateTime = extendedDateTime.setMinutes(
				extendedDateTime.getMinutes() + 10
			);
			extendedDateTime = new Date(extendedDateTime).toISOString();
			this.timeAlreadyExtended === true;
			return extendedDateTime;
		},
	},

	beforeMount() {
		this.getExpiration();
		let sessionCookie = this.$cookies.get(this.sessionKey);
	},
	mounted() {
		this.$parent.$on('removePerformanceId', this.removePerformanceId);
	},
};
</script>
